import { AxiosError } from 'axios';
import { GET_SCHOOLS_FOR_SCHOOL_CANDIDATE_PAYMENT } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { LookupListApiItem } from '../../api/user/model';
import { useCustomQuery } from '../../hooks/query';
import { GET_SCHOOLS_FOR_SCHOOL_CANDIDATE_PAYMENT_QUERY_KEY } from '../../constants/queryKeys';

interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}

export const useGetSchoolsForSchoolCandidatePayment = ({ onSuccess, onError }: Input) => {
  const getSchoolsForSchoolCandidatePayment = async () => {
    const res = await axiosClient.get<LookupListApiItem[]>(
      GET_SCHOOLS_FOR_SCHOOL_CANDIDATE_PAYMENT
    );
    return res.data;
  };

  return useCustomQuery(
    GET_SCHOOLS_FOR_SCHOOL_CANDIDATE_PAYMENT_QUERY_KEY,
    getSchoolsForSchoolCandidatePayment,
    {
      onSuccess,
      onError,
    }
  );
};
